<!--
    Selectors: the field carries `fieldTestId`; mention-input-layer (the coloured text), mention-input-name
    (a coloured name), note-mention-list, note-mention-option (data-user-id, data-active).
-->
<div class="mi" [class.mi--reply]="variant === 'reply'">
    <!--
        Draws the text with the names coloured; the field above it has transparent text. The zero-width
        space at the end: a trailing line break needs something after it, or the layer is one line short.
    -->
    <div class="mi__layer" data-testid="mention-input-layer" aria-hidden="true" #layer>
        <ng-container *ngFor="let seg of segments"
            ><span class="mi__name" data-testid="mention-input-name" *ngIf="seg.mention">{{ seg.text }}</span
            ><ng-container *ngIf="!seg.mention">{{ seg.text }}</ng-container></ng-container
        >&#8203;</div>
    <textarea
        #field
        hamInput
        class="mi__field"
        [attr.data-testid]="fieldTestId"
        [rows]="rows"
        [hideRemoveXButton]="true"
        [attr.placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onInput($event)"
        (keydown)="onKeydown($event)"
        (keyup)="onKeyup($event)"
        (click)="onCaretMove()"
        (scroll)="syncScroll()"
    ></textarea>
</div>

<!-- The CPMM annotations' list, in the flyout layer so a pane never cuts it off. -->
<div
    class="mi-list"
    data-testid="note-mention-list"
    hamFlyout
    *ngIf="listOpen"
    [position]="listPosition"
    [style.transform]="listPosition.isAbove ? 'translateY(-100%)' : null"
    (closeFlyout)="closeList()"
    (mousedown)="onListMousedown($event)"
>
    <ul>
        <li
            class="mi-list__option"
            data-testid="note-mention-option"
            *ngFor="let user of options; let i = index"
            [attr.data-user-id]="user.userId"
            [attr.data-active]="i === activeIndex ? 'true' : null"
            [class.mi-list__option--active]="i === activeIndex"
            (mouseenter)="activeIndex = i"
            (click)="pick(user)"
        >
            @{{ user.displayName }}
        </li>
    </ul>
</div>
